import CreateAudioModal from './modals/CreateAudioModal';
import CreateDocumentModal from './modals/CreateDocumentModal';
import CreateVideoModal from './modals/CreateVideoModal';
import {
  AudioOutlined,
  DownOutlined,
  FileTextOutlined,
  VideoCameraOutlined
} from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import { MenuProps } from 'antd/lib';
import { useCan, useModal } from '@refinedev/core';

interface ContentCreateDropdownProps {
  onFinish?: () => void;
  libraryId: string;
}

export const ContentCreateDropdown = ({
  onFinish,
  libraryId
}: ContentCreateDropdownProps) => {
  const { data: canCreate } = useCan({
    resource: 'library_contents',
    action: 'create'
  });
  const createDocumentModal = useModal();
  const createAudioModal = useModal();
  const createVideoModal = useModal();

  if (!canCreate?.can) {
    return null;
  }

  const handleMenuClick: MenuProps['onClick'] = e => {
    const modals = [createDocumentModal, createAudioModal, createVideoModal];

    for (const modal of modals) {
      modal.close();
    }

    switch (e.key) {
      case 'document': {
        createDocumentModal.show();

        break;
      }

      case 'audio': {
        createAudioModal.show();

        break;
      }

      case 'video': {
        createVideoModal.show();

        break;
      }
      // No default
    }
  };

  const items: MenuProps['items'] = [
    {
      label: 'Áudio',
      key: 'audio',
      icon: <AudioOutlined />
    },
    {
      label: 'Vídeo',
      key: 'video',
      icon: <VideoCameraOutlined />
    },
    {
      label: 'Documento',
      key: 'document',
      icon: <FileTextOutlined />
    }
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick
  };

  return (
    <>
      <Dropdown menu={menuProps} className="!block ml-auto w-fit mb-4">
        <Button type="primary">
          <Space>
            Adicionar conteúdo
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>

      <CreateDocumentModal
        modal={createDocumentModal}
        libraryId={libraryId}
        onFinish={onFinish}
      />
      <CreateAudioModal
        modal={createAudioModal}
        libraryId={libraryId}
        onFinish={onFinish}
      />
      <CreateVideoModal
        modal={createVideoModal}
        libraryId={libraryId}
        onFinish={onFinish}
      />
    </>
  );
};
